import { describe, it, expect, vi, beforeEach, afterEach } from 'vitest';
import { fetchPdfSrc } from './pdf-utils';

const mockFetch = vi.fn();
vi.stubGlobal('fetch', mockFetch);

const mockFileReader = {
  addEventListener: vi.fn(),
  readAsDataURL: vi.fn(),
  result: null as string | null,
};

vi.stubGlobal(
  'FileReader',
  vi.fn(() => mockFileReader)
);

describe('Unit | Utility | pdf-utils | fetchPdfSrc', () => {
  beforeEach(() => {
    vi.clearAllMocks();
    mockFileReader.result = null;
  });

  afterEach(() => {
    vi.restoreAllMocks();
  });

  it('returns null when pdfUrl is empty string', async () => {
    const result = await fetchPdfSrc('');

    expect(result).toBeNull();
    expect(mockFetch).not.toHaveBeenCalled();
  });

  it('successfully converts PDF to data URL', async () => {
    const mockPdfUrl = 'https://example.com/document.pdf';
    const mockBlob = new Blob(['mock pdf content'], { type: 'application/pdf' });
    const mockDataUrl = 'data:application/pdf;base64,bW9jayBwZGYgY29udGVudA==';

    mockFetch.mockResolvedValueOnce({
      blob: () => Promise.resolve(mockBlob),
    });

    mockFileReader.addEventListener.mockImplementation((event, callback) => {
      if (event === 'load') {
        mockFileReader.result = mockDataUrl;
        setTimeout(() => {
          (callback as () => void)();
        }, 0);
      }
    });

    const result = await fetchPdfSrc(mockPdfUrl);

    expect(mockFetch).toHaveBeenCalledWith(mockPdfUrl, { method: 'GET' });
    expect(mockFileReader.addEventListener).toHaveBeenCalledWith('load', expect.any(Function));
    expect(mockFileReader.addEventListener).toHaveBeenCalledWith('error', expect.any(Function));
    expect(mockFileReader.readAsDataURL).toHaveBeenCalledWith(mockBlob);
    expect(result).toBe(mockDataUrl);
  });

  it('returns null when fetch fails', async () => {
    const mockPdfUrl = 'https://example.com/invalid.pdf';

    mockFetch.mockRejectedValueOnce(new Error('Network error'));

    const result = await fetchPdfSrc(mockPdfUrl);

    expect(mockFetch).toHaveBeenCalledWith(mockPdfUrl, { method: 'GET' });
    expect(result).toBeNull();
  });

  it('returns null when response.blob() fails', async () => {
    const mockPdfUrl = 'https://example.com/document.pdf';

    mockFetch.mockResolvedValueOnce({
      blob: () => Promise.reject(new Error('Blob conversion failed')),
    });

    const result = await fetchPdfSrc(mockPdfUrl);

    expect(mockFetch).toHaveBeenCalledWith(mockPdfUrl, { method: 'GET' });
    expect(result).toBeNull();
  });
});
